import React from "react";
import Link from "../../components/link";
import { Translation, t } from "../../core/translate";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../redux/brand";
import styled from "styled-components";

const StyledSharedLinks = styled.div`
  margin-top: 15px;
  text-align: center;
`;

const StyledSharedLink = styled.div`
  margin: 3px 0 7px 0;
`;

const StyledLink = styled(Link)`
  display: inline-block;
  vertical-align: bottom;
`;

const SharedLinks = ({
  showVitalsourceBrand,
  forgotPasswordEnabled,
  registerEnabled,
  signInEnabled
}) => (
  <StyledSharedLinks>
    {forgotPasswordEnabled && (
      <StyledSharedLink>
        <StyledLink naked href="/user/forgot" inline>
          <Translation id="signin.forgot-password">Forgot Password</Translation>
        </StyledLink>
      </StyledSharedLink>
    )}
    {registerEnabled && (
      <StyledSharedLink>
        <StyledLink naked href="/user/registration" inline>
          <Translation
            id={
              showVitalsourceBrand
                ? "signin.create-a-brand-account"
                : "signin.create-an-account"
            }
            brandName="VitalSource"
          >
            -Create a VitalSource account-
          </Translation>
        </StyledLink>
      </StyledSharedLink>
    )}
    {signInEnabled && (
      <StyledSharedLink>
        <Translation
          id="registration.already-have-account"
          action={
            <StyledLink naked href="/user/signin" inline>
              <Translation id="signin.signin-button">Sign In</Translation>
            </StyledLink>
          }
        >
          Already have an account? Sign In!
        </Translation>
      </StyledSharedLink>
    )}
  </StyledSharedLinks>
);

const mapStateToProps = (state, ownProps) => ({
  forgotPasswordEnabled:
    ownProps.forgotPassword &&
    brandSelectors.getBrandValue(state, "ForgotPassword.enabled", true),
  registerEnabled:
    ownProps.register &&
    !brandSelectors.getBrandValue(state, "AccountCompletion.ssoOnly", false),
  showVitalsourceBrand: brandSelectors.getBrandValue(
    state,
    "Account.showVitalsourceBrand",
    false
  ),
  signInEnabled:
    ownProps.signIn &&
    brandSelectors.getBrandValue(state, "Signin.enabled", true)
});

export default connect(mapStateToProps)(SharedLinks);
